const model = {
    submitting: false,
    errors: null,
    brandDetails: null,
    success: false,
};

export default model;
